export default "__VITE_ASSET__7b77c77e__"